// file imports
import { Box } from "@mui/system";
import Stack from "@mui/material/Stack";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Header from "../../common/header/Header";
import LibraryTabs from "../../pages/MyLibrary/LibraryTabs";
import { useEffect } from "react";
import { Link as RouterLink, useSearchParams } from "react-router-dom";
import { ROUTES } from "../../config/app-constants";

const CommentLibrary = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const hash = window.location.hash;
    const queryString = hash.split("?")[1];
    const urlParams = new URLSearchParams(queryString);
    useEffect(() => {
        const stored = sessionStorage.getItem("company-key");
        const keyFromUrl = (searchParams.get("key") || "").trim();

        // Only write if we truly have nothing saved and the URL has a real value
        const hasNothingSaved =
            stored == null || stored === "null" || stored === "undefined" || stored === "";

        if (hasNothingSaved && keyFromUrl) {
            sessionStorage.setItem("company-key", keyFromUrl);
        }
        const initializePendo = () => {
            if (typeof window.pendo === 'undefined') {
                window.pendo = window.pendo || [];
            }
            if (Array.isArray(window.pendo)) {
                window.pendo.push({
                    visitor: {
                        id: urlParams.get("id"),
                        user_name: urlParams.get("name"),
                        Address: "",
                        Email: urlParams.get("email"),
                        Role: urlParams.get("role")
                    },
                    account: {
                        company_id: sessionStorage.getItem("company-key"),
                        ParentCompany: "ISN",
                    },
                });
                return;
            }
        };
        setTimeout(initializePendo, 300);

        // After (and only after) we have a real key in storage, strip the query param
        const nowStored = sessionStorage.getItem("company-key");
        if (nowStored && keyFromUrl) {
            const next = new URLSearchParams(searchParams); // clone, don't mutate original
            next.delete("key");
            setSearchParams(next, { replace: true });
        }
        // it's fine if this runs twice in React StrictMode; second run sees no "key" and does nothing
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Scroll to top on page load
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        // Comment library container
        <Box className="library-container">
            {/* Header */}
            <Header />
            {/* Breadcrumb: Template Editor > Content Library. Comment Library has no
                specific-template context (it's a standalone /library route), so "Template
                Editor" returns to the templates list rather than a particular template. */}
            <div className="breadcrumb-container">
                <Stack className="stack-container" spacing={1}>
                    <Breadcrumbs separator=">" aria-label="breadcrumb">
                        <Link component={RouterLink} to={ROUTES.TEMPLATES} underline="hover" className="breadcrumb-normal">
                            Template Editor
                        </Link>
                        <Typography className="breadcrumb-last">Content Library</Typography>
                    </Breadcrumbs>
                </Stack>
            </div>
            {/* Library tabs */}
            <LibraryTabs />
        </Box>
    );
};

export default CommentLibrary;